import PropTypes from 'prop-types';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import LoadingButton from '@mui/lab/LoadingButton';
// components
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import { useSnackbar } from 'src/components/snackbar';
// utils
import axios, { API_ENDPOINTS } from 'src/utils/axios';

// ----------------------------------------------------------------------

export default function UserPasswordDialog({ open, onClose, user, onSuccess }) {
  const { enqueueSnackbar } = useSnackbar();

  const PasswordSchema = Yup.object().shape({
    newPassword: Yup.string()
      .min(6, 'Password deve ter pelo menos 6 caracteres')
      .required('Nova password é obrigatória'),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref('newPassword')], 'As passwords não coincidem')
      .required('Confirmação é obrigatória'),
  });

  const defaultValues = {
    newPassword: '',
    confirmPassword: '',
  };

  const methods = useForm({
    resolver: yupResolver(PasswordSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      await axios.put(`${API_ENDPOINTS.users.password}${user.id}/password`, {
        newPassword: data.newPassword,
      });
      enqueueSnackbar('Password atualizada com sucesso', { variant: 'success' });
      reset(defaultValues);
      onSuccess();
    } catch (error) {
      console.error(error);
      enqueueSnackbar(error.message || 'Ocorreu um erro', { variant: 'error' });
    }
  });

  const handleClose = () => {
    reset(defaultValues);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="sm" fullWidth>
      <FormProvider methods={methods} onSubmit={onSubmit}>
        <DialogTitle>Alterar Password</DialogTitle>

        <DialogContent>
          <Stack spacing={2.5} sx={{ mt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              Alterar password para: <strong>{user?.firstname} {user?.lastname}</strong> ({user?.email})
            </Typography>

            <RHFTextField
              name="newPassword"
              label="Nova Password"
              type="password"
            />

            <RHFTextField
              name="confirmPassword"
              label="Confirmar Password"
              type="password"
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={handleClose} color="inherit">
            Cancelar
          </Button>
          <LoadingButton type="submit" variant="contained" loading={isSubmitting}>
            Alterar Password
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
}

UserPasswordDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  user: PropTypes.object,
  onSuccess: PropTypes.func,
};
